/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';



/**
 * Fonctions du plugin BEP
 */
@Injectable({
  providedIn: 'root',
})
export class PluginBepService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation pluginBepHelloHelloAnonymous
   */
  static readonly PluginBepHelloHelloAnonymousPath = '/api/plugin/bep/hello-anonymous';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pluginBepHelloHelloAnonymous()` instead.
   *
   * This method doesn't expect any request body.
   */
  pluginBepHelloHelloAnonymous$Response(params?: {
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, PluginBepService.PluginBepHelloHelloAnonymousPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pluginBepHelloHelloAnonymous$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pluginBepHelloHelloAnonymous(params?: {
  }): Observable<string> {

    return this.pluginBepHelloHelloAnonymous$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation pluginBepHelloHelloAuthenticated
   */
  static readonly PluginBepHelloHelloAuthenticatedPath = '/api/plugin/bep/hello-auth';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pluginBepHelloHelloAuthenticated()` instead.
   *
   * This method doesn't expect any request body.
   */
  pluginBepHelloHelloAuthenticated$Response(params?: {
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, PluginBepService.PluginBepHelloHelloAuthenticatedPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pluginBepHelloHelloAuthenticated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pluginBepHelloHelloAuthenticated(params?: {
  }): Observable<string> {

    return this.pluginBepHelloHelloAuthenticated$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
